export const CREATE = 'CREATE';
export const UPDATE = 'UPDATE';
export const DELETE = 'DELETE';
export const FETCH_ALL = 'FETCH_ALL';
export const LIKE = 'LIKE';
export const FETCH_SERVICE = 'FETCH_SERVICE';
export const FETCH_COUNTERS_ON_SERVICE = 'FETCH_COUNTERS_ON_SERVICE';

export const AUTH = 'AUTH';
export const LOGOUT = 'LOGOUT';
export const MONITOR = 'MONITOR';
export const UPDATE_CUSTOMER = 'UPDATE_CUSTOMER';
export const TRANSHISTORY = 'TRANSHISTORY';

export const AUTH_COUNTERSTAFF = 'AUTH_COUNTERSTAFF';
export const LOGOUT_COUNTERSTAFF = 'LOGOUT_COUNTERSTAFF';

export const AUTH_ADMIN = 'AUTH_ADMIN';
export const LOGOUT_ADMIN = 'LOGOUT_ADMIN';
export const GET_ADMIN_DATA = 'GET_ADMIN_DATA';
export const GET_ADMIN = 'GET_ADMIN';
export const UPDATE_ADMIN = 'UPDATE_ADMIN';
export const FETCH_ADVERTISE = 'FETCH_ADVERTISE';

export const DELETE_COUNTERSTAFF = 'DELETE_COUNTERSTAFF';
export const UPDATE_COUNTERSTAFF = 'UPDATE_COUNTERSTAFF';
export const GET_ONE_COUNTERSTAFF = 'GET_ONE_COUNTERSTAFF';
export const CREATE_COUNTERSTAFF = 'CREATE_COUNTERSTAFF';
export const FETCH_ALL_COUNTERSTAFFS = 'FETCH_ALL_COUNTERSTAFFS';
export const UPDATE_COUNTERSTAFF_USER = 'UPDATE_COUNTERSTAFF_USER';

export const DELETE_COUNTER = 'DELETE_COUNTERS';
export const UPDATE_COUNTER = 'UPDATE_COUNTERS';
export const GET_ONE_COUNTER = 'GET_ONE_COUNTERS';
export const CREATE_COUNTER = 'CREATE_COUNTERS';
export const FETCH_ALL_COUNTERS = 'FETCH_ALL_COUNTERS';
export const FETCH_NUMBER_COUNTERS = 'FETCH_NUMBER_COUNTERS';
export const FETCH_SHOW_MISSED = 'FETCH_SHOW_MISSED';

export const GET_TICKET = 'GET_TICKET';
export const GET_TICKET_DATA = 'GET_TICKET_DATA';
export const LEAVE_QUEUING = 'LEAVE_QUEUING';
export const FETCH_WAITING = 'FETCH_WAITING';
export const FETCH_TRANSACTION = 'FETCH_TRANSACTION';
export const LEAVE_QUEUING_WAITING = 'LEAVE_QUEUING_WAITING';
export const FETCH_CALLING = 'FETCH_CALLING';
export const FETCH_TICKET_COUNTERSTAFFS = 'FETCH_TICKET_COUNTERSTAFFS';

export const FETCH_NUMBER_WAITING = 'FETCH_NUMBER_WAITING';
export const FETCH_NUMBER_SERVED = 'FETCH_NUMBER_SERVED';
export const FETCH_NUMBER_MISSED = 'FETCH_NUMBER_MISSED';

export const FETCH_NUMBER_WAITING_ALL = 'FETCH_NUMBER_WAITING_ALL';
export const FETCH_NUMBER_SERVED_ALL = 'FETCH_NUMBER_SERVED_ALL';
export const FETCH_NUMBER_MISSED_ALL = 'FETCH_NUMBER_MISSED_ALL';

export const FETCH_TOTAL_NUMBER_SERVED = 'FETCH_TOTAL_NUMBER_SERVED';
export const FETCH_AVERAGE_SERVICETIME = 'FETCH_AVERAGE_SERVICETIME';

export const FETCH_AVEREPORTS = 'FETCH_AVEREPORTS';
export const FETCH_RATE = 'FETCH_RATE';
export const FETCH_TOTALVOL = 'FETCH_TOTALVOL';
export const FETCH_TOTALVISITOR = 'FETCH_TOTALVISITOR';
